import React, {useContext, useEffect, useState} from 'react';

import {TableColumn, TableSettings} from "../../../tableSettings";
import AbstractListView, {
  DataFetchResult,
  ExportRowRenderer,
  ListCustomFilterRenderer,
  ListOrderBy,
  ListRowRenderer
} from "../../common/AbstractListView";

import constants from '../../../constants';

import {containerStatusList} from '../tableSettings';
import {Search} from "../../../filtering";

import {
  DateRenderer,
  DateTimeRenderer,
  FloatRenderer,
  NullableCheckboxIconRenderer,
  TextAlignLeftRenderer,
  TextAlignRightRenderer,
  TextRenderer
} from '../../../uiControls/SmartTableRenderers';
import JobListViewContext, { IJobListViewContext, RightClickContext } from '../../common/JobListViewContext';
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import InfoAreaDrawer from '../../../uiControls/infoArea/InfoAreaDrawer';
import {JobNames} from '../../../framework.core/JobNames';
import {OtOpContainerListItem} from '../../../fms.data/models/OtOpContainerListItem';
import * as XCol from '../../../framework.core/XExportColumn';
import ListViewShortcutMenu from '../../common/ListViewShortcutMenu';
import { ActionButtonItem, borderColors, splitMenuItemsIntoSections } from '../../../ui/ActionButton';
import ToolboxMenuItem from '../../../uiControls/ToolboxMenuItem';
import Menu, { IfmsMenuItem } from '../../../ui/menu/Menu';
import IfmsModal from '../../../ui/IfmsModal';
import { formatDate } from '../../../dateUtils';
import Date from '../../../ui/Date';
import SecondaryButton from '../../../ui/SecondaryButton';
import { SQLField, SQLInfo, SQLType } from '../../../framework.core/data/SQLInfo';
import { ApiResult, InsertResultsWithData } from '../../../framework.core/data/ApiResult';
import _ from 'lodash';
import ApplicationContext from '../../../ApplicationContext';
import { getFmsGlobal } from '../../../globals';
import { SuntekSettings, SystemSettings } from '../../../ifmsTypes';//
import {useHistory} from 'react-router-dom';
import { NavigationType, openNewPage } from '../../../util/navigationHelpers';
import { LastEventRenderer, RQFilterRenderer } from '../../common/commonListRenderers';
import cntrBlack from '../../../img/container_tracking-black.svg';
import cntrWhite from '../../../img/container_tracking-white.svg';
import PrimaryInverseButton from '../../../ui/PrimaryInverseButton';

async function DoSave(rowId: number, dataIndex: any, datePopupInputValue: string|null, appContext: any, rowMblId:number) {
  let sqlInfo: SQLInfo = new SQLInfo({
    tableName: "T_GENCONTAINER",
    type: SQLType.Update,
    fields: [
      new SQLField({ fieldName: `f_${dataIndex}`, propertyName: dataIndex, value: datePopupInputValue }),
    ],
    key: new SQLField({ fieldName: "F_Id", propertyName: "Id", value: rowId }),
  });

  const apiResult: ApiResult<InsertResultsWithData> = await appContext.api.updateContainerInfo(sqlInfo);
}

function ClickAbleDateRenderer({ cell, data, row }: any) {
  const jobListContext = useContext(JobListViewContext);
  const l = data[row.index];

  function onDateCellClick() {
    if (jobListContext.rowExtrasId) {
      return; // Some row is already selected
    }

    jobListContext.setRowExtrasId(l.id);
  }
  let content: React.ReactNode = <></>;
  if (cell.value)
    content = formatDate(cell.value);

  return (
    <div className="ifms-table-default" style={{ width: '100%', minHeight: '16px', cursor: 'pointer' }} onClick={onDateCellClick}>{content}</div>
  );
}

function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as OtOpContainerListItem;
  const appContext = useContext(ApplicationContext);
  const fmsGlobal = getFmsGlobal();
  const {switchToMbl} = useSelectedOperations();

  const items = [
    { label: 'Search', shortcut: 'F5', separator: false, newCol: false },
    { label: 'Go to Other Shipment List', shortcut: 'F6', separator: true, newCol: false },
    { label: 'CNTR Tracking Info', shortcut: '', separator: false },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
  }));

  function openContainerTracking() {
      window.open(`https://trackinginfo.suntekscm.com/?licid=${fmsGlobal.AcmeID}&cntr=${selectedElement.containerNo}&email=${appContext.user?.email}`);
  }

  function onMenuItemSelected(item: IfmsMenuItem) {
    switch (item.index) {
      case 0:
        jobListContext.triggerTableSearch('F5');
        break;
      case 1:
        switchToMbl();
        break;
      case 2:
        openContainerTracking();
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function RefRenderer({value, data, row}: any) {
  const {switchToMblForDetail} = useOperations();

  return <PrimaryInverseButton onClick={() => switchToMblForDetail(data[row.index])} style={{width: '100%', lineHeight:'1em'}}>{value}</PrimaryInverseButton>
}

function CsListCommands() {
  return null;
}

function CsListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function formatData(data:Array<OtOpContainerListItem>) {
  return data;
}

function useOperations() {
  const history = useHistory();
  const jobListContext = useContext(JobListViewContext);

  function switchToMblFor(c: OtOpContainerListItem | null) {
    if (!c) {
      return;
    }

    jobListContext.setFilterForScreenExternally('/common/joblistview/otherShipment/otherShipment', 
    'id', 'Ref. #', c.genMainId, 'updated', false, true, null, 'refNo', c.refNo, false,true);
    
    openNewPage(history, `/common/joblistview/otherShipment/otherShipment`, NavigationType.newPage);
  }
  
  function switchToMblForDetail(c: OtOpContainerListItem | null) {
    if (!c) {
      return;
    }
    
    openNewPage(history, `/otherShipment/otherShipment/view/${c.genMainId}`, NavigationType.newPage);
  }

  return {switchToMblFor, switchToMblForDetail};
}

function useSelectedOperations(){
  const jobListContext = useContext(JobListViewContext);

  const { switchToMblFor } = useOperations();

  function switchToMbl() {
    const selectedElement = jobListContext.selectedElement as OtOpContainerListItem;
    switchToMblFor(selectedElement);
  }

  return {switchToMbl};
}

function CsListViewExtras() {
  useFunctionKeys({onFunction: onFunctionKey});

  const jobListContext = useContext(JobListViewContext);
  const {switchToMbl} = useSelectedOperations();
  const [unprocessedFkey, setUnprocessedFkey] = useState<string|null>(null);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if(unprocessedFkey === "F6"){
      switchToMbl();
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey:string) {
    if (['F6','F11'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  return (
    <InfoAreaDrawer
      showContent={jobListContext.infoAreaContent}
      jobName={JobNames.OtherContainer}
      jobId={(jobListContext.selectedElement as OtOpContainerListItem|null)?.id ?? 0}
      onClose={() => jobListContext.setInfoAreaContent('none')}
      //hideLogHistory={true}
    />
  );
}

function ContainerPopup({ rowId, onClose, cell, save }: { rowId: any, onClose: any, cell: any, save: any }) {
  const [datePopupInputValue, setDatePopupInputValue] = useState<string | null>(null);
  
  return (
    <IfmsModal isBlueHeader cancelOnEsc onCancel={onClose} draggable isOpen title={`Input - ${cell.column.Header}`} width="260px">
      <div className='report-popup'>
        <div style={{ height: '30px', display: 'flex' }}>
          <span>{cell.column.Header}</span>
          <div style={{ width: '80px', marginLeft: '10px', marginTop: '-1px' }}>
            <Date
              value={formatDate(datePopupInputValue)}
              onChange={date => { setDatePopupInputValue(date ?? null) }}
            />
          </div>
        </div>
        <div className="report-footer" >
          <SecondaryButton size="regular" focusable={true} onClick={() => { save(rowId, cell.column.dataIndex, datePopupInputValue) }}>
            SAVE
          </SecondaryButton>&nbsp;&nbsp;
          <SecondaryButton size="regular" focusable={true} onClick={onClose}>
            CANCEL
          </SecondaryButton>
        </div>
      </div>
    </IfmsModal>
  );
}

/**
 * Concrete implementation for Container List screen
 *
 * @class ContainerStatusListView
 * @extends {AbstractListView}
 */
 class ContainerStatusListView extends AbstractListView {
  async fetchAndFormatData(api: any, search: Search): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(JobNames.OtherContainer, 'OtOpContainerListItem',
    OtOpContainerListItem.calculateSearchParameters(search, OtOpContainerListItem.MapSearchFields),
      1,
      search.pageSize);

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }

    return { data: formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
      {
        accessor: 'trStatus',
        renderer: RQFilterRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
    ];
  }

  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanImportMbl;
  }

  getRowRenderers(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings, listCount: number, useDarkMode: boolean ): ListRowRenderer[] {
    const useTrackingService = suntekSettings?.company?.trackingService ?? false;
    return OtOpContainerListItem.getExportCollection(useTrackingService).map(x => {
      const colRenderer:ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      // if(x.dataIndex === 'containerNo') {
      //   colRenderer.Cell = CntrNoRenderer;
      //   colRenderer.Header = () => <span><u>Container No</u></span>;
      // }
      if(x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      if(x.align === XCol.XAlignType.Right) colRenderer.Cell = TextAlignRightRenderer;
      if(x.dataIndex === "stat") {
        colRenderer.Cell = () => <span></span>
        colRenderer.Header = () => <span></span>;
      }
      else if(x.dataIndex === "refNo") colRenderer.Cell = RefRenderer;
      else if(x.dataIndex === 'trStatus'){
        colRenderer.Cell = (props: any) => <LastEventRenderer {...props} jobName={JobNames.OtherContainer} />;
        colRenderer.Header =  () => <div><img style={{float:'left'}} height="16px" src={useDarkMode ? cntrWhite : cntrBlack} alt='' />Container Tracking</div>;
      }
      else if(x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if (x.type === XCol.XCellType.Date) {
        if (x.dataIndex === "eta")
          colRenderer.Cell = DateRenderer
        else {
          colRenderer.Cell = ClickAbleDateRenderer
        }
      }
      else if(x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      else if (x.type === XCol.XCellType.Double) {
        if (x.dataIndex === 'pkgs')
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={0} />;
        else
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={2} />;
      }
      return colRenderer;
    });
  }
  
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({accessor: 'status', changedValue: (value: any)=> { return value['status'] === 'PC' ? 'Period Close' : ''}});
    colRenderer.push({ accessor: 'pkgs', changedValue: (value: any) => { return value['pkgs'] } });
    colRenderer.push({ accessor: 'bookingDate', changedValue: (value: any) => { return formatDate(value['bookingDate']) } });
    colRenderer.push({ accessor: 'ord', changedValue: (value: any) => { return formatDate(value['ord']) } });
    colRenderer.push({ accessor: 'inDate', changedValue: (value: any) => { return formatDate(value['inDate']) } });
    colRenderer.push({ accessor: 'loadDate', changedValue: (value: any) => { return formatDate(value['loadDate']) } });
    colRenderer.push({ accessor: 'atd', changedValue: (value: any) => { return formatDate(value['atd']) } });
    colRenderer.push({ accessor: 'ata', changedValue: (value: any) => { return formatDate(value['ata']) } });
    colRenderer.push({ accessor: 'unloadDate', changedValue: (value: any) => { return formatDate(value['unloadDate']) } });
    colRenderer.push({ accessor: 'carrierRls', changedValue: (value: any) => { return formatDate(value['carrierRls']) } });
    colRenderer.push({ accessor: 'customRls', changedValue: (value: any) => { return formatDate(value['customRls']) } });
    colRenderer.push({ accessor: 'rAtd', changedValue: (value: any) => { return formatDate(value['rAtd']) } });
    colRenderer.push({ accessor: 'inlandEta', changedValue: (value: any) => { return formatDate(value['inlandEta']) } });
    colRenderer.push({ accessor: 'rAta', changedValue: (value: any) => { return formatDate(value['rAta']) } });
    colRenderer.push({ accessor: 'lastFreeDay', changedValue: (value: any) => { return formatDate(value['lastFreeDay']) } });
    colRenderer.push({ accessor: 'puDate', changedValue: (value: any) => { return formatDate(value['puDate']) } });
    colRenderer.push({ accessor: 'outDate', changedValue: (value: any) => { return formatDate(value['outDate']) } });
    colRenderer.push({ accessor: 'dcDate', changedValue: (value: any) => { return formatDate(value['dcDate']) } });
    colRenderer.push({ accessor: 'emptyReturn', changedValue: (value: any) => { return formatDate(value['emptyReturn']) } });
    colRenderer.push({ accessor: 'etd', changedValue: (value: any) => { return formatDate(value['etd']) } });
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'id',
      orderByAscending: false,
     };
   }

   renderRowExtras(rowId: number | null, context: IJobListViewContext, cell: any, appContext: any): React.ReactNode | null {
     if (!rowId) {
       return null;
     }

     function onClose() {
       context.setRowExtrasId(null);
     }

     function save(rowId: number, dataIndex: any, datePopupInputValue: string) {
       if (cell.value !== datePopupInputValue) {
         DoSave(rowId, dataIndex, datePopupInputValue, appContext, cell.row.original.oiMblId);
         onClose();
         context.reloadData();
       }
       else
         onClose();
     }

     return <ContainerPopup rowId={rowId} onClose={onClose} save={save} cell={cell} />
   }

  getTableSettings(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): TableSettings {
    const tsettings = containerStatusList;
    const useTrackingService = suntekSettings?.company?.trackingService ?? false;
    const cols = OtOpContainerListItem.getExportCollection(useTrackingService);
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });

    return tsettings;
    
  }

  getTableDomIdSuffix(): string {
    let domIdSuffix = ''; 
    if (this.suntekSettings?.company?.trackingService) domIdSuffix += '-trackingService';

    return domIdSuffix;
  }

  renderCommands() {
    return (
      <CsListCommands />
    );
  }

  renderBeforeConfigureButton() {
    return (
      <CsListToolbar />
    );
  }


  renderExtras() {
    return <CsListViewExtras />
  }

  getViewUrlFor() {
    return '';
  }

  getListViewTitle() {
    return 'Container List';
  };

  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }
};

export default ContainerStatusListView;
